<template>
  <div class="row mr-0 ml-0">
    <div class="col-md-12 ag-filter-box-header">
      <h6 class="p-3">{{ t(module.title) }}</h6>
      <input
        type="text"
        name="dates"
        id="filterDateRange"
        v-model="customRange"
      />
      <ag-date-select
        :filters="module.filters"
        v-if="!module.filterVersion"
        v-show="!module.noDateSelect"
        :dateid="'filter'"
      ></ag-date-select>
    </div>
    <div class="col-md-5 p-0">
      <a
        class="ag-filter-setter"
        data-toggle="modal"
        data-target="#customizeModal"
      >
        <center>{{ t("Customize") }}</center>
      </a>
      <div v-if="module.textSearch">
        <div
          class="form-control text-search"
          v-for="(item, key) in module.filters.filter(
            (f) => f.type === 'fullTextSearch'
          )"
          :key="key"
        >
          <div class="form-group has-feedback">
            <input
              type="text"
              maxlength="191"
              name="quick"
              placeholder="Quick Search for a term"
              class="form-control"
              v-model="item.vmodel"
            />
            <i class="ag-icon ag-icon_darkSearch text-search-icon"></i>
            <i
              class="ag-icon ag-icon_smallclose text-search-close-icon"
              v-if="item.vmodel"
              @click="clearFullTextSearchFilter()"
            ></i>
          </div>
        </div>
      </div>

      <div
        style="height: 74vh; overflow-y: scroll"
        v-show="
          !module.filters.find((f) => f.type === 'fullTextSearch') ||
          (module.filters.find((f) => f.type === 'fullTextSearch') &&
            !module.filters.find((f) => f.type === 'fullTextSearch').vmodel)
        "
      >
        <div
          v-for="(item, key) in module.filters.filter((f) => !f.hidden)"
          :key="key"
          class="accordion"
          id="accordionExample"
          v-show="
            !item.hideOnRole ||
            (item.hideOnRole && item.hideOnRole !== loggedInUser.role)
          "
          :class="{ disabled: item.disabled }"
        >
          <div
            class="card"
            v-role="[Roles.AGMSAdmin, Roles.PartnerAdmin, Roles.CompanyAdmin, Roles.SiteAdmin]"
          >
            <div class="card-header bg-transparent" :id="'heading' + key">
              <h2 class="mb-0">
                <button
                  class="btn btn-block text-left collapsed"
                  type="button"
                  data-toggle="collapse"
                  :data-target="'#collapse' + key"
                  aria-expanded="true"
                  :aria-controls="'#collapse' + key"
                >
                  {{ t(item.title) }}
                </button>
              </h2>
            </div>

            <div
              :id="'collapse' + key"
              class="collapse"
              :aria-labelledby="'heading' + key"
              data-parent="#accordionExample"
            >
              <div class="card-body">
                <ag-site-and-group
                  v-if="item.type === 'siteAndGroup'"
                  :type="item.selectType"
                  :key="compKey"
                  :value="{ label: item.selectedLabel, value: item.vmodel }"
                  :selected-site-data="selectedSite"
                  :selected-groups-data="selectedGroups"
                  :selected-company-data="selectedCompany"
                  @change="handleChange($event, item)"
                  @changeOnAllGroup="handleChangeOnAllGroup($event, item)"
                  @siteChange="handleSiteChange($event, item)"
                  @companyChange="handleCompanyChange($event, item)"
                />
                <ag-event-filter
                  v-if="item.type === 'eventFilter'"
                  :key="compKey"
                  :module="module"
                  :selected-site-data="selectedSite"
                  :selected-groups-data="selectedGroups"
                  :selected-company-data="selectedCompany"
                  @dataChange="handleChangeEventFilters($event, item)"
                  ref="eventFilterRef"
                />
                <ag-event-advanced-filter
                  v-if="item.type === 'eventAdvancedFilter'"
                  :key="compKey"
                  @dataChange="handleChangeEventFilters($event, item)"
                />
                <input
                  class="w-100 form-control"
                  v-model="item.vmodel"
                  type="text"
                  maxlength="191"
                  :placeholder="`Type ${t(item.title)}`"
                  v-mask="item.mask"
                  v-if="item.type === 'wordstyped' && item.mask"
                />
                <input
                  class="w-100 form-control"
                  v-model="item.vmodel"
                  type="text"
                  maxlength="191"
                  :placeholder="`Type ${t(item.title)}`"
                  v-if="item.type === 'wordstyped' && !item.mask"
                />
                <select
                  v-if="item.type === 'select' && !item.textInputStatus"
                  class="form-select form-control form-select-sm w-100"
                  v-model="item.vmodel"
                  @change="checkTextInput(item)"
                >
                  <option value="" disabled selected v-if="item.placeholder">
                    {{ item.placeholder }}
                  </option>
                  <option :value="null">All</option>

                  <option
                    v-for="(option, key) in item.data"
                    :key="key"
                    :value="
                      item.valueParam ? option[item.valueParam] : option.id
                    "
                  >
                    {{ option[item.param] }}
                  </option>
                </select>
                <div v-if="item.textInputStatus">
                  <select
                    class="form-select form-control form-select-sm w-100"
                    v-model="item.textInputModel"
                    @change="checkTextInput(item)"
                  >
                    <option value="" disabled selected v-if="item.placeholder">
                      {{ item.placeholder }}
                    </option>
                    <option :value="null">All</option>

                    <option
                      v-for="(option, key) in item.data"
                      :key="key"
                      :value="
                        item.valueParam ? option[item.valueParam] : option.id
                      "
                    >
                      {{ option[item.param] }}
                    </option>
                  </select>

                  <input
                    class="w-100 mt-3"
                    v-model="item.vmodel"
                    type="text"
                    maxlength="191"
                  />
                </div>

                <input
                  class="w-100 form-control"
                  v-model="item.vmodel"
                  type="date"
                  v-if="item.type === 'date'"
                />
                <ag-computer-select
                  v-if="item.type === 'computer'"
                  @onComputerChange="item.vmodel = $event"
                  ref="computerSelect"
                  :groups="selectedGroups"
                  :current-site="selectedSite"
                  :group="
                    module.filters.filter((f) => f.type == 'siteAndGroup')[0]
                      .vmodel
                  "
                />
                <ag-computer-user-select
                  v-if="item.type === 'computerUser'"
                  @computerChange="item.vmodel = $event.target.value"
                  @userChange="userSelected($event)"
                  ref="computerSelectUser"
                  :groups="selectedGroups"
                  :current-site="selectedSite"
                  :group="
                    module.filters.filter((f) => f.type == 'siteAndGroup')[0]
                      .vmodel
                  "
                />
                <ag-policy-select
                  v-if="item.type === 'policy'"
                  @change="item.vmodel = $event.target.value"
                  :group="
                    module.filters.filter((f) => f.type == 'siteAndGroup')[0]
                      .vmodel
                  "
                >
                </ag-policy-select>
              </div>
            </div>
          </div>
          <div
            class="card"
            v-role="[Roles.GroupAdmin, Roles.GroupAudit]"
            v-if="item.type !== 'siteAndGroup'"
          >
            <div class="card-header bg-transparent" :id="'heading' + key">
              <h2 class="mb-0">
                <button
                  class="btn btn-block text-left collapsed"
                  type="button"
                  data-toggle="collapse"
                  :data-target="'#collapse' + key"
                  aria-expanded="true"
                  :aria-controls="'#collapse' + key"
                >
                  {{ t(item.title) }}
                </button>
              </h2>
            </div>

            <div
              :id="'collapse' + key"
              class="collapse"
              :aria-labelledby="'heading' + key"
              data-parent="#accordionExample"
            >
              <div class="card-body">
                <ag-event-filter
                  v-if="item.type === 'eventFilter'"
                  :key="compKey"
                  :module="module"
                  @dataChange="handleChangeEventFilters($event, item)"
                  ref="eventFilterRef"
                />
                <ag-event-advanced-filter
                  v-if="item.type === 'eventAdvancedFilter'"
                  :key="compKey"
                  @dataChange="handleChangeEventFilters($event, item)"
                />
                <input
                  class="w-100 form-control"
                  v-model="item.vmodel"
                  type="text"
                  maxlength="191"
                  v-if="item.type === 'wordstyped'"
                />
                <select
                  v-if="item.type === 'select'"
                  class="form-select form-select-sm form-control w-100"
                  v-model="item.vmodel"
                >
                  <option value="" disabled selected v-if="item.placeholder">
                    {{ item.placeholder }}
                  </option>
                  <option :value="null">All</option>

                  <option
                    v-for="(option, key) in item.data"
                    :key="key"
                    :value="option.id"
                  >
                    {{ option[item.param] }}
                  </option>
                </select>
                <input
                  class="w-100 form-control"
                  v-model="item.vmodel"
                  type="date"
                  v-if="item.type === 'date'"
                />
                <ag-computer-select
                  v-if="item.type === 'computer'"
                  @onComputerChange="item.vmodel = $event"
                  :groups="selectedGroups"
                  :current-site="selectedSite"
                  :group="
                    module.filters.filter((f) => f.type == 'siteAndGroup')[0]
                      .vmodel
                  "
                />
                <ag-computer-user-select
                  v-if="item.type === 'computerUser'"
                  @computerChange="item.vmodel = $event.target.value"
                  @userChange="userSelected($event)"
                  :groups="selectedGroups"
                  :current-site="selectedSite"
                  :group="
                    module.filters.filter((f) => f.type == 'siteAndGroup')[0]
                      .vmodel
                  "
                />
              </div>
            </div>
          </div>
        </div>
        <div v-role="[Roles.AGMSAdmin, Roles.PartnerAdmin, Roles.CompanyAdmin, Roles.SiteAdmin]">
          <h5
            v-if="!module.filters.filter((f) => f.vmodel).length"
            class="filter-placeholder"
          >
            {{$t("agFilterText")}}
          </h5>
        </div>
      </div>
    </div>
    <div
      class="col-md-7 d-flex justify-content-between flex-column"
      style="max-height: 95vh; overflow: auto"
    >
      <div>
        <div
          class="d-flex pr-5 pl-5 pt-3 pb-3 justify-content-center"
          style="gap: 15px; flex-wrap: wrap"
        >
          <button
            class="
              ag-button
              border-0
              ag-button_grey ag-button_radius
              pr-4
              pl-4
              pt-1
              pb-1
            "
            @click="resetFilters"
          >
            {{ t("reset") }}
          </button>
          <button
            v-if="!module.ignoreSaveFilter"
            class="
              ag-button
              border-0
              ag-button_grey ag-button_radius
              pr-4
              pl-4
              pt-1
              pb-1
            "
            @click="showSaveFilter"
          >
            {{ t("savefilters") }}
          </button>
          <button
            class="
              ag-button
              border-0
              ag-button_primary ag-button_radius
              pr-4
              pl-4
              pt-1
              pb-1
            "
            @click="onSearch"
          >
            {{ t("search") }}
          </button>
        </div>
        <div class="save-container mb-4" v-if="saveField">
          <input
            v-model="filterTitle"
            placeholder="Name your new filter"
            type="text"
            maxlength="191"
            class="mr-2"
            style="text-align: center"
          />
          <button
            class="ag-button border-0 ag-button_primary ag-button_radius"
            @click="saveCurrentFilters"
          >
            {{$t("save")}}
          </button>
        </div>
        <div
          class="ag-filter_params-filters"
          v-if="module.filters.filter((f) => f.vmodel).length"
        >
          <div
            v-for="(item, index) in module.filters.filter((f) => f.vmodel)"
            :key="index"
            style="display: inline-grid; position: relative"
            v-show="!item.hide"
          >
            <span v-if="item.type === 'select'" class="filter-box">
              <span class="filter-title"
                >{{
                  item.title === "companySiteGroup" ? "group" : item.title
                }}:</span
              >
              <span class="filter-value">{{
                item.data.find((f) => f.id == item.vmodel)
                  ? item.data.find((f) => f.id == item.vmodel)[item.param]
                  : item.vmodel
              }}</span>
            </span>
            <span v-else class="filter-box">
              <span class="filter-title"
                >{{
                  item.title === "companySiteGroup" ? "group" : item.title
                }}:</span
              >
              <span
                class="filter-value"
                v-if="!Array.isArray(item.selectedLabel)"
                >{{
                  item.selectedLabel ? item.selectedLabel : item.vmodel
                }}</span
              >
              <span
                class="filter-value"
                v-if="Array.isArray(item.selectedLabel)"
              >
                <span v-for="(val, vIndex) in item.selectedLabel" :key="vIndex"
                  >{{ val }},
                </span>
              </span>
            </span>
            <span
              class="ag-icon ag-icon_smallclose filter-clear"
              @click="clearFilter(item)"
            ></span>
          </div>
        </div>
        <div class="ag-filter_params justify-content-center d-flex mt-4" v-else>
          <h5>Apply a filter or search for assets</h5>
        </div>
      </div>
      <ag-table
        v-if="!module.ignoreSaveFilter"
        style="position: relative; top: -22px"
        :options="module.savedFilter"
      ></ag-table>
    </div>
  </div>
</template>

<script>
/*eslint-disable */
import { defineComponent } from "vue";
import { useI18n } from "vue-i18n";
import { useStore } from "@/store";
import { mapGetters } from "vuex";
const store = useStore();
import { notify } from "@kyvg/vue3-notification";
import { GeneralActionTypes } from "@/store/modules/general/action-types";
import AgTable from "@/components/ag-table/index.vue";
import AgSiteAndGroup from "./components/ag-site-and-group.vue";
import AgEventFilter from "./components/ag-event-filter.vue";
import AgEventAdvancedFilter from "./components/ag-advanced-filter.vue";
import AgComputerSelect from "./components/ag-computer-select.vue";
import AgComputerUserSelect from "./components/ag-computer-user-select.vue";
import AgDateSelect from "@/components/ag-date-select";
import api from "@/store/axiosAgsc";
import dateOptions from "@/helpers/DateOptions";
import { Roles } from "@/helpers/enums/Roles";
import { error } from "jquery";
import AgPolicySelect from "@/components/ag-filter/components/ag-policy-select";
import moment from "moment/moment";
import { mask } from "vue-the-mask";

export default defineComponent({
  name: "ag-filter",
  setup() {
    const { t, locale } = useI18n();
    return { t, locale, Roles };
  },
  directives: { mask },
  components: {
    AgPolicySelect,
    AgTable,
    AgComputerSelect,
    AgSiteAndGroup,
    AgEventFilter,
    AgEventAdvancedFilter,
    AgDateSelect,
    AgComputerUserSelect,
  },
  computed: {
    ...mapGetters(["loggedInUser"]),
    getUserId() {
      return store.state.auth.user.filter((item) => item.type == "uid")[0]
        .value;
    },
  },
  props: {
    module: {
      type: Object,
      default: null,
    },
    readyToUseFilters: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data: () => ({
    dateOptions: dateOptions,
    saveField: false,
    filterTitle: "",
    modal: {
      id: "filterModal",
      items: [],
    },
    filter: {
      site: null,
      group: null,
      date: dateOptions[2],
    },
    compKey: 0,
    selectedGroups: [],
    selectedSite: null,
    selectedCompany: null,
  }),
  watch: {
    $route(to, from) {
      if (this.module.filters) {
        this.module.filters.forEach((element) => {
          element.vmodel = "";
        });

        const lastSearchType = localStorage.getItem("last_search_type");
        if (
          this.module.pageName === lastSearchType &&
          localStorage.getItem("last_search")
        ) {
          if (this.$route.query.searchResults) {
            this.module.filters = JSON.parse(
              localStorage.getItem(
                "last_search",
                JSON.stringify(this.module.filters)
              )
            );
            this.$emit("search");
          }
        }
      }
    },
  },
  mounted() {
    const module = this.module;
    const readyToUseFilters = this.readyToUseFilters;
    const range = module.filters.find((f) => f.param == "range");
    const jQuery = window.jQuery;
    this.loadFullTextSearch();
    this.fillMiniSavedFiltersTable(this.module.genre);
    jQuery.noConflict();
    jQuery('input[name="dates"]').daterangepicker(
      {
        showDropdowns: true,
        opens: "center",
        drops: "down",
        timePicker: true,
        timeFormat: 'hh:mm A',
        startDate: moment().startOf('day').hour(0).minute(0),
        endDate: moment().endOf('day').hour(23).minute(59),
      },
      function (start, end) {
        range.vmodel = {
          start: start.format("YYYY-MM-DD hh:mm A"),
          end: end.format("YYYY-MM-DD hh:mm A"),
        };
        range.selectedLabel = `${start.format("L")} - ${end.format("L")}`;
        // range.vmodel = null;

        const filter = readyToUseFilters.readyToUseFilters;
        filter.startDate = start.format("YYYY-MM-DD hh:mm A");
        filter.endDate = end.format("YYYY-MM-DD hh:mm A");
        readyToUseFilters.readyToUseFilters = filter;
        readyToUseFilters.component.options.fetchTable(
          readyToUseFilters.component.options
        );
      }
    );
  },
  methods: {
    loadFullTextSearch() {
      if (this.module.textSearch) {
        const index = this.module.filters.findIndex(
          (f) => f && f.type === "fullTextSearch"
        );
        if (index === -1) {
          this.module.filters.push({
            title: "Text Search",
            apiEquivalent: "textSearch",
            type: "fullTextSearch",
            requestKey: "fullTextSearch",
            param: "Text Search",
            hidden: true,
            vmodel: null,
          });
        }
      }
    },
    clearFullTextSearchFilter() {
      this.$parent.$parent.resetFilters();
      ++this.compKey;

      const index = this.module.filters.findIndex(
        (f) => f && f.type === "fullTextSearch"
      );
      this.module.filters[index].vmodel = null;
    },
    onSearch() {
      localStorage.setItem("last_search", JSON.stringify(this.module.filters));
      localStorage.setItem("last_search_type", this.module.pageName);
      this.$parent.$parent.searchWithFilters();
      store.dispatch(GeneralActionTypes.FILTER_STATUS, false);
    },
    userSelected(event) {
      const user = this.module.filters.find((i) => i.type === "username");
      if (user) {
        user.vmodel = event;
      }
    },
    handleChangeEventFilters(e, item) {
      for (const [key, value] of Object.entries(e)) {
        if (
          value &&
          ((Array.isArray(value) && value.length > 0) ||
            (typeof value === "object" && !Array.isArray(value)) ||
            typeof value === "string" ||
            value instanceof String) &&
          key != "isTrusted"
        ) {
          const filterData = {
            vmodel: Array.isArray(value)
              ? value
              : typeof value === "object"
              ? value.id
              : value,
            title: Array.isArray(value)
              ? key
              : typeof value === "object"
              ? value.name
              : key,
            selectedLabel: Array.isArray(value)
              ? value
              : typeof value === "object"
              ? value.label
              : value,
            key: key,
            hidden: true,
            requestKey: key,
          };

          const filterIndex = this.module.filters.findIndex(
            (i) => i && i.key === key
          );
          if (filterIndex > -1) {
            this.module.filters[filterIndex] = filterData;
          } else {
            this.module.filters.push(filterData);
          }
        } else if ((!value || value.length === 0) && key != "isTrusted") {
          const filterIndex = this.module.filters.findIndex(
            (i) => i && i.key === key
          );
          if (filterIndex > -1) {
            this.module.filters[filterIndex].vmodel = "";
            this.module.filters[filterIndex].selectedLabel = "";
          }
        }
      }
    },
    handleChange(e, item) {
      if (e.type !== "group") {
        const filterData = {
          vmodel: e.data.value,
          title: e.data.title,
          selectedLabel: e.data.label,
          key: e.data.key,
          hidden: true,
          type: e.data.title,
          requestKey: e.data.key,
        };

        if (e.type == "site" && !e.data.value) {
          this.selectedSite = null;
          this.selectedGroups = [];
          const filterIndex = this.module.filters.findIndex(
            (i) => i && i.type === "siteAndGroup"
          );
          if (filterIndex > -1) {
            this.module.filters[filterIndex].vmodel = null;
          }
        }

        if (e.type == "company" && !e.data.value) {
          this.selectedSite = null;
          this.selectedGroups = [];
          this.selectedCompany = null;

          const filterIndex = this.module.filters.findIndex(
            (i) => i && i.type === "Site"
          );
          if (filterIndex > -1) {
            this.module.filters[filterIndex].vmodel = null;
          }
        }

        const filterIndex = this.module.filters.findIndex(
          (i) => i && i.key === e.data.key
        );
        if (filterIndex > -1) {
          this.module.filters[filterIndex] = filterData;
        } else {
          this.module.filters.push(filterData);
        }
      } else {
        const data = e.data;
        if (data && Array.isArray(data) && data.length) {
          item.vmodel = [];
          item.selectedLabel = "";
          data.forEach((element) => {
            item.vmodel.push(element.value);
            item.selectedLabel = `${
              item.selectedLabel
                ? item.selectedLabel + ", "
                : item.selectedLabel
            } ${element.label}`;
          });
          this.selectedGroups = item.vmodel;
        } else {
          this.selectedGroups = [item.vmodel];
          item.vmodel = data.value;
          item.selectedLabel = data.label;
        }
        item.hide = false;
      }
    },
    handleChangeOnAllGroup(e, item) {
      if (e && Array.isArray(e) && e.length) {
        item.vmodel = [];
        item.selectedLabel = "";
        e.forEach((element) => {
          item.vmodel.push(element.value);
        });
      } else {
        item.vmodel = e.value;
      }
      item.hide = true;
    },
    handleSiteChange(e, item) {
      const indexSiteGroup = this.module.filters.findIndex(
        (f) => f && f.type === "siteAndGroup"
      );
      if (indexSiteGroup > -1) {
        this.module.filters[indexSiteGroup].vmodel = null;
      }
      const index = this.module.filters.findIndex(
        (f) => f && f.type === "siteComp"
      );
      if (!e) {
        if (index > -1) {
          this.module.filters[index].vmodel = null;
        }
        return;
      }
      if (index === -1) {
        this.module.filters.push({
          title: "Site",
          type: "siteComp",
          hide: false,
          selectedLabel: e.label,
          vmodel: e.value,
        });
      } else {
        const index = this.module.filters.findIndex(
          (f) => f && f.type === "siteComp"
        );
        this.module.filters[index] = {
          title: "Site",
          type: "siteComp",
          hide: false,
          selectedLabel: e.label,
          vmodel: e.value,
        };
      }
    },
    clearFilter(item) {
      item.vmodel = null;
      // ++this.compKey;
      if (item.type == "Site") {
        this.selectedSite = null;
        this.selectedGroups = [];
        const filterIndex = this.module.filters.findIndex(
          (i) => i && i.type === "siteAndGroup"
        );
        if (filterIndex > -1) {
          this.module.filters[filterIndex].vmodel = null;
        }

        const filterIndexComputer = this.module.filters.findIndex(
          (i) => i && i.type === "computer"
        );
        if (filterIndexComputer > -1) {
          this.module.filters[filterIndexComputer].vmodel = null;
        }
      }

      if (item.type == "Company") {
        this.selectedSite = null;
        this.selectedGroups = [];
        this.selectedCompany = null;

        const filterIndex = this.module.filters.findIndex(
          (i) => i && i.type === "Site"
        );
        if (filterIndex > -1) {
          this.module.filters[filterIndex].vmodel = null;
        }

        const filterIndexGroup = this.module.filters.findIndex(
          (i) => i && i.type === "siteAndGroup"
        );
        if (filterIndexGroup > -1) {
          this.module.filters[filterIndexGroup].vmodel = null;
        }

        const filterIndexComputer = this.module.filters.findIndex(
          (i) => i && i.type === "computer"
        );
        if (filterIndexComputer > -1) {
          this.module.filters[filterIndexComputer].vmodel = null;
        }
      }

      if (item.type == "siteAndGroup") {
        this.selectedGroups = [];
        const filterIndexComputer = this.module.filters.findIndex(
          (i) => i && i.type === "computer"
        );
        if (filterIndexComputer > -1) {
          this.module.filters[filterIndexComputer].vmodel = null;
        }
      }

      const eventFilterRefs = this.$refs.eventFilterRef;

      if (Array.isArray(eventFilterRefs)) {
        eventFilterRefs.forEach((ref) => {
          if (ref && ref.clearSelectedData) {
            ref.clearSelectedData(item);
          }
        });
      } else {
        if (eventFilterRefs && eventFilterRefs.clearSelectedData) {
          eventFilterRefs.clearSelectedData(item);
        } 
      }
      console.log(this.module.filters)
    },
    handleSiteChange(e, item) {
      this.selectedSite = e;
    },
    handleCompanyChange(e, item) {
      this.selectedCompany = e;
      if (!e) {
        this.selectedSite = null;
        this.selectedGroups = [];
        this.selectedCompany = null;
        const filterIndex = this.module.filters.findIndex(
          (i) => i && i.type === "siteAndGroup"
        );
        if (filterIndex > -1) {
          this.module.filters[filterIndex].vmodel = null;
        }
        const filterIndexSite = this.module.filters.findIndex(
          (i) => i && i.type === "Site"
        );
        if (filterIndexSite > -1) {
          this.module.filters[filterIndexSite].vmodel = null;
        }
      }
    },
    resetFilters() {
      if (this.$refs.computerSelect && this.$refs.computerSelect.length > 0) {
        this.$refs.computerSelect.forEach((element) => {
          element.search = "";
          element.computers = [];
        });
      }
      if (
        this.$refs.computerSelectUser &&
        this.$refs.computerSelectUser.length > 0
      ) {
        this.$refs.computerSelectUser.forEach((element) => {
          element.search = "";
          element.computers = [];
        });
      }

      localStorage.setItem("last_search_type", "");
      localStorage.setItem("last_search", "");
      this.$parent.$parent.resetFilters();
      ++this.compKey;
    },
    checkTextInput(model) {
      if(model.param === "alarmType") {
        let url = `Alarm/GetAlarmConditionCategories?conditionCategoryType=${model.vmodel}`;
        if(!model.vmodel) {
          url = `Alarm/GetAlarmConditionCategories`;
        }
        api.get(url, null).then((response) => {
          const item = this.module.filters.find(i => i.title === 'Category');
          item.data = response.data.entityData;
          item.vmodel = null;
        });
      }
      const find = model.data.findIndex((i) => i.id === model.vmodel);
      if (find > -1) {
        if (model.data[find].showTextInput) {
          model.vmodel = "";
          model.textInputStatus = true;
          model.textInputModel = model.data[find].id;
        } else {
          model.textInputStatus = false;
          model.textInputModel = null;
        }
      }
      const findTextInput = model.data.findIndex(
        (i) => i.id === model.textInputModel
      );
      if (findTextInput > -1) {
        if (model.data[findTextInput].showTextInput) {
          model.textInputStatus = true;
          model.textInputModel = model.data[findTextInput].id;
        } else {
          model.textInputStatus = false;
          model.textInputModel = null;
        }
      }
    },
    onDateChanged(data) {
      if (data.value === "custom") {
        document.getElementById("filterDateRange").click();
      } else {
        (this.module.filters.find((f) => f.type == "date") || {}).vmodel =
          data.value;
        (
          this.module.filters.find((f) => f.type == "date") || {}
        ).selectedLabel = data.label;
      }

      this.filter.date = data;
    },
    onValueChanged(data) {
      const readyToUseFilters = this.readyToUseFilters;
      if (data.type === "default") {
        readyToUseFilters.component.options.readyToUseFilters = {
          policyFileVersion: data.version.start,
          policyFileVersionLimit: data.version.end,
          startDate: moment()
            .utc()
            .startOf("day")
            .subtract(7, "days")
            .utc()
            .format("YYYY-MM-DDTHH:mm:ss.SSS"),
          endDate: moment().utc().format("YYYY-MM-DDTHH:mm:ss.SSS"),
        };
      }
      if (data.type === "interval") {
        readyToUseFilters.component.options.readyToUseFilters = {
          startDate:
            data && data.data && data.data.value
              ? moment(data.data.value).format("YYYY-MM-DDTHH:mm:ss.SSS")
              : moment()
                  .startOf("day")
                  .subtract(7, "days")
                  .utc()
                  .format("YYYY-MM-DDTHH:mm:ss.SSS"),
          endDate: moment().utc().format("YYYY-MM-DDTHH:mm:ss.SSS"),
        };
      }
      // readyToUseFilters.component.options.fetchTable(readyToUseFilters.component.options);
    },
    saveCurrentFilters() {
      if (this.filterTitle != "") {
        let filtersJSON = [];
        this.module.filters.forEach((item) => {
          if (item.vmodel != null && item.vmodel != "") {
            if (item.apiEquivalent === "range" && item.vmodel) {
              filtersJSON.push({
                name: item.apiEquivalent || item.title,
                value: item,
              });
            } else {
              filtersJSON.push({
                name: item.apiEquivalent || item.title,
                value: item.vmodel,
                selectedLabel: item.selectedLabel,
              });
            }
          }
        });
        if (filtersJSON.length > 0) {
          let body = {
            userGuid: this.getUserId,
            title: this.filterTitle,
            filterJsonData: JSON.stringify(filtersJSON),
            page: this.module.pageName,
          };
          api
            .post("UserFilter/CreateOrUpdateUserFilter", body)
            .then((res) => {
              if (res.data.entityData.id != null) {
                notify({
                  title: "New filter Was Added",
                  type: "success",
                  duration: 4000,
                });
                this.saveField = false;
                this.fillMiniSavedFiltersTable(this.module.genre);
              }
            })
            .catch((e) => {
              notify({
                title: "An Error Occurred..",
                type: "error",
                text: JSON.stringify(e.Message),
                duration: 8000,
              });
            });
        } else {
          notify({
            title: "Empty Filters",
            type: "error",
            text: "You should fill at least one filter.",
            duration: 8000,
          });
        }
      } else {
        notify({
          title: "Empty Title",
          type: "error",
          text: "The name or the title of the filter can not be empty.",
          duration: 8000,
        });
      }
    },
    showSaveFilter() {
      this.saveField = !this.saveField;
      this.filterTitle = "";
    },
    fillMiniSavedFiltersTable(genre) {
      let role = (store.state.auth.user.find((f) => f.type == "role") || {})
        .value;
      if (!process.env.NODE_ENV || process.env.NODE_ENV === "development") {
        role = Roles.AGMSAdmin;
        // role = Roles.SiteAudit;
        // role = Roles.GroupAdmin;
        // role = Roles.SiteAdmin;
      }
      // if (
      //   role == Roles.GroupAdmin &&
      //   this.module.filters[0].type == "siteAndGroup"
      // ) {
      //   const group = store.state.auth.group;
      //   this.module.filters[0].vmodel = group.key;
      //   this.module.filters[0].selectedLabel = group.value;
      // }

      // this.module.savedFilter.isLoading = true;
      if (!this.module.ignoreSaveFilter) {
        api
          .get(
            "UserFilter/GetUserAllSavedFilters?userGuid=" + this.getUserId,
            null
          )
          .then((res) => {
            if (genre === "filter") {
              return;
            }
            const data = res.data.entityData[genre];
            if (!this.module.ignoreSaveFilter) {
              (this.module.savedFilter || {}).rows =
                this.paginate(data, 5, 1) || [];
              (this.module.savedFilter || {}).total = data.length;
              (this.module.savedFilter || {}).fetchTable = (props) => {
                const page = props.page;
                const pageSize = props.pageSize;
                (this.module.savedFilter || {}).rows =
                  this.paginate(data, pageSize, page) || [];
              };
            }
          })
          .finally(() => {
            // this.module.savedFilter.isLoading = false;
          });
      }
    },
    paginate(array, page_size, page_number) {
      return array.slice(
        (page_number - 1) * page_size,
        page_number * page_size
      );
    },
  },
});
</script>

<style lang="scss">
#filterDateRange {
  visibility: hidden;
  position: absolute;
}

.save-container {
  display: flex;
  justify-content: center;
  button {
    font-size: 12px;
  }
  input::placeholder {
    color: rgb(121, 121, 121);
    font-size: 12px;
    margin-left: 1rem;
  }
}

.ag-filter_params-filters {
  display: flex;
  flex-wrap: wrap;
  grid-template-columns: 1fr 1fr;
  font-size: 12px;
  grid-gap: 0.5rem 2rem;
  padding-bottom: 30px;

  .filter-title {
    color: #333;
    font-weight: 600;
    margin-right: 4px;
    text-transform: capitalize;
  }
  .filter-value {
    color: #666;
  }
  .filter-box {
    padding: 5px;
    background: #dad9d9;
    border-radius: 4px;
    padding-right: 25px;
    word-break: break-all;
  }

  .filter-clear {
    position: absolute;
    right: 5px;
    top: calc(50% - 9px);
    &:hover {
      cursor: pointer;
    }
  }
}

.accordion > .card {
  overflow: inherit !important;
}

.multiselect-single-label {
  text-overflow: ellipsis;
  overflow: hidden;
  width: 210px;
  white-space: nowrap;
  display: inline-block;
  height: 38px;
  display: inline-block;
  padding-top: 8px;
}

.ag-filter-box-header {
  border-bottom: 2px solid #d8dfe3;
  display: flex;
  justify-content: space-between;
  align-items: center;
  h6 {
    border: none !important;
  }
}

.daterangepicker {
  z-index: 9999999;
  right: 59px !important;
}

.filter-placeholder {
  color: #b7c6cd;
  padding: 1.5rem 3rem;
  text-align: center;
  line-height: 1.6rem;
}

.accordion.disabled {
  opacity: 0.5;
  pointer-events: none;
}

.text-search {
  height: 56px;
}
.text-search input {
  padding-right: 40px;
  padding-left: 30px;
}
.text-search-icon {
  position: absolute;
  top: 18px;
  width: 16px;
  height: 16px;
  left: 20px;
}
.text-search-close-icon {
  position: absolute;
  right: 18px;
  width: 33px;
  height: 26px;
  top: 14px;
  text-align: right;
  cursor: pointer;
}
</style>
